import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
/** Renders `as` (or `<a>`) with the props. External links open in a new tab safely. */
export const ShellLink = forwardRef(function ShellLink({ as: Component, children, ...props }, ref) {
    if (Component)
        return (_jsx(Component, { ref: ref, ...props, children: children }));
    return (_jsx("a", { ref: ref, ...props, children: children }));
});
/** Whether a path matches an item's href: exact, or a prefix at a segment boundary. */
export function pathMatches(href, currentPath, exact = false) {
    const path = href.split('?')[0]?.split('#')[0] ?? href;
    if (!path)
        return false;
    if (exact || path === '/')
        return currentPath === path;
    return currentPath === path || currentPath.startsWith(`${path}/`);
}
//# sourceMappingURL=link.js.map